module.exports = __webpack_public_path__ + "static/media/prescription.9e6e133e.svg";